import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone: true,
})
export class FilterPipe implements PipeTransform {

   transform(agencies: any[], filterText: string): any[] {
    if (!agencies || !filterText) {
      return agencies;
    }

    filterText = filterText.toLowerCase();

    return agencies.map(agency => {
      return {
        ...agency,
        sites: agency.sites.filter(site => site.name.toLowerCase().includes(filterText))
      };
    }).filter(agency => agency.sites.length > 0);
  }

}
